import { RAJESH_TRANSPORT } from "../../../../../helper/companyIdhardcode";

export const BranchReceiveHeader = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'sno', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 40,
        },
        headerSx: { minWidth: '50px', textAlign: 'left' },
        weight:40
    },
    {
        id: 1, header: 'LR No\nMan.LR No', exportHead: 'LR No\nMan.LR No', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 2, header: 'Challan\nNo', exportHead: 'Challan\nNo', field: 'ChallanNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 3, header: 'Rcvr. Date\nRcvr. Time', exportHead: 'Rcvr. Date\nRcvr. Time', field: 'ReceiptDate', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 4, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'Sender', isSelected: true, isDefault: false, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 5, header: 'Sndr. GSTIN\nSndr. EmailID.', exportHead: 'Sndr. GSTIN\nSndr. EmailID.', field: 'SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 6, header: 'Rcvr. Name\nRcvr. No', exportHead: 'Rcvr. Name\nRcvr. No', field: 'RecName', isSelected: true, isDefault: false, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 7, header: 'Rcvr. GSTIN\nRcvr. EmailID', exportHead: 'Rcvr. GSTIN\nRcvr. EmailID', field: 'ReceiverGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 8, header: 'Item\nDetails', exportHead: 'Item\nDetails', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 9, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Units', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 10, header: 'Frt\nChrg', exportHead: 'Frt\nChrg', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 11, header: 'Cart.\nChrg.', exportHead: 'Cart.\nChrg.', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 12, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 13, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 14, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 15, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 16, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
];
export const BranchReceiveHeaderFormatedLR = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'sno', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 40,
        },
        headerSx: { minWidth: '50px', textAlign: 'right' }
    },
    {
        id: 1, header: 'Formatted LRNO\nMan.LR No', exportHead: 'Formatted LRNO\nMan.LR No', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 2, header: 'Challan\nNo', exportHead: 'Challan\nNo', field: 'ChallanNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 3, header: 'Rcvr. Date\nRcvr. Time', exportHead: 'Rcvr. Date\nRcvr. Time', field: 'ReceiptDate', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 4, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'Sender', isSelected: true, isDefault: false, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 5, header: 'Sndr. GSTIN\nSndr. EmailID.', exportHead: 'Sndr. GSTIN\nSndr. EmailID.', field: 'SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 6, header: 'Rcvr. Name\nRcvr. No', exportHead: 'Rcvr. Name\nRcvr. No', field: 'RecName', isSelected: true, isDefault: false, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 7, header: 'Rcvr. GSTIN\nRcvr. EmailID', exportHead: 'Rcvr. GSTIN\nRcvr. EmailID', field: 'ReceiverGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 8, header: 'Item\nDetails', exportHead: 'Item\nDetails', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 9, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Units', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 10, header: 'Frt\nChrg', exportHead: 'Frt\nChrg', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 11, header: 'Cart.\nChrg.', exportHead: 'Cart.\nChrg.', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 12, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 13, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 14, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 15, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 16, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
];
export const BranchReceiveHeaderForBoth = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'sno', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 40,
        },
        headerSx: { minWidth: '50px', textAlign: 'right' }
    },
    {
        id: 1, header: 'LR No\nMan.LR No', exportHead: 'LR No\nMan.LR No', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 2, header: 'Formatted\nLRNO', exportHead: 'Formatted\nLRNO', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 3, header: 'Challan\nNo', exportHead: 'Challan\nNo', field: 'ChallanNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 4, header: 'Rcvr. Date\nRcvr. Time', exportHead: 'Rcvr. Date\nRcvr. Time', field: 'ReceiptDate', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 5, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'Sender', isSelected: true, isDefault: false, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 6, header: 'Sndr. GSTIN\nSndr. EmailID.', exportHead: 'Sndr. GSTIN\nSndr. EmailID.', field: 'SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 7, header: 'Rcvr. Name\nRcvr. No', exportHead: 'Rcvr. Name\nRcvr. No', field: 'RecName', isSelected: true, isDefault: false, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 8, header: 'Rcvr. GSTIN\nRcvr. EmailID', exportHead: 'Rcvr. GSTIN\nRcvr. EmailID', field: 'ReceiverGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 9, header: 'Item\nDetails', exportHead: 'Item\nDetails', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 10, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Units', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 11, header: 'Frt\nChrg', exportHead: 'Frt\nChrg', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 12, header: 'Cart.\nChrg.', exportHead: 'Cart.\nChrg.', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 13, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 14, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 15, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 16, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 17, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
];
export const BranchReceiveHeaderForPortrait = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'sno', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 40,
        },
        headerSx: { minWidth: '50px', textAlign: 'right' }
    },
    {
        id: 1, header: 'LR No\nMan.LR No', exportHead: 'LR No\nMan.LR No', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 2, header: 'Formatted\nLRNO', exportHead: 'Formatted\nLRNO', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 3, header: 'Challan\nNo', exportHead: 'Challan\nNo', field: 'ChallanNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 4, header: 'Rcvr. Date\nRcvr. Time', exportHead: 'Rcvr. Date\nRcvr. Time', field: 'ReceiptDate', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 5, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'Sender', isSelected: true, isDefault: false, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 6, header: 'Rcvr. Name\nRcvr. No', exportHead: 'Rcvr. Name\nRcvr. No', field: 'RecName', isSelected: true, isDefault: false, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 7, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Units', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 8, header: 'Frt\nChrg', exportHead: 'Frt\nChrg', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 9, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
];
export const BranchReceiveHeaderForRemoveGST = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'sno', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 40,
        },
        headerSx: { minWidth: '50px', textAlign: 'right' }
    },
    {
        id: 1, header: 'LR No\nMan.LR No', exportHead: 'LR No\nMan.LR No', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    // {
    //     id: 2, header: 'Formatted\nLRNO', exportHead: 'Formatted\nLRNO', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    //     pdfColSx: {
    //         halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
    //     },
    //     headerSx: { minWidth: '80px', textAlign: 'left' }
    // },
    {
        id: 3, header: 'Challan\nNo', exportHead: 'Challan\nNo', field: 'ChallanNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 4, header: 'Rcvr. Date\nRcvr. Time', exportHead: 'Rcvr. Date\nRcvr. Time', field: 'ReceiptDate', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 5, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'Sender', isSelected: true, isDefault: false, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 6, header: 'Sndr. EmailID.', exportHead: 'Sndr. EmailID.', field: 'SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 7, header: 'Rcvr. Name\nRcvr. No', exportHead: 'Rcvr. Name\nRcvr. No', field: 'RecName', isSelected: true, isDefault: false, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 8, header: 'Rcvr. EmailID', exportHead: 'Rcvr. EmailID', field: 'ReceiverGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 9, header: 'Item\nDetails', exportHead: 'Item\nDetails', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 10, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Units', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 11, header: 'Frt\nChrg', exportHead: 'Frt\nChrg', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 12, header: 'Cart.\nChrg.', exportHead: 'Cart.\nChrg.', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 13, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 14, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 15, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    // {
    //     id: 16, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
    //     pdfColSx: {
    //         halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
    //     },
    //     headerSx: { minWidth: '80px', textAlign: 'right' }
    // },
    {
        id: 16, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
];

export const calculateTotalTableWidth = (columns) => {
    let totalWidth = 0;

    columns.forEach((column) => {
        const minCellWidth = column.pdfColSx.minCellWidth;
        totalWidth += minCellWidth;
    });

    return totalWidth;
};
export const calculateDynamicFormatLandscape = (desiredWidth) => {
    const a4LandscapeAspectRatio = 1122 / 793;

    const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

    return [desiredWidth, dynamicHeight];
};
export const calculateDynamicFormatPortrait = (desiredWidth) => {
    const a4LandscapeAspectRatio = 793 / 1122;

    const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

    return [desiredWidth, dynamicHeight];
};

export const BranchTransRecExcelHeader = [
    { header: 'S/N', field: 'sno' },
    { header: 'LR No', field: 'LRNO' },
    { header: 'Man.LR No', field: 'LRNO' },
    { header: 'Challan No', field: 'ChallanNo' },
    { header: 'Trans. Date', field: 'ReceiptDate' },
    { header: 'Trans. Time', field: 'ReceiptDate' },
    { header: 'Sndr. Name', field: 'Sender' },
    { header: 'Sndr. No.', field: 'Sender' },
    { header: 'Sndr. GSTIN', field: 'SenderGSTN' },
    { header: 'Sndr. eMail.', field: 'SenderGSTN' },
    { header: 'Rcvr. Name', field: 'RecName' },
    { header: 'Rcvr. No', field: 'RecName' },
    { header: 'Rcvr. GSTIN', field: 'ReceiverGSTN' },
    { header: 'Rcvr. eMail', field: 'ReceiverGSTN' },
    { header: 'Item Details', field: 'ItemDetails' },
    { header: 'Item Units', field: 'Units' },
    { header: 'Frt Chrg', field: 'Freight' },
    { header: 'Cart. Chrg.', field: 'CartageAmount' },
    { header: 'Ham. Chrg.', field: 'HamaliCharge' },
    { header: 'Oth. Chrg.', field: 'OtherCharges' },
    { header: 'Val. Chrg.', field: 'Valuation' },
    { header: 'Bkg. GST', field: 'BookingGST' },
    { header: 'Net. Amt.', field: 'NetAmount' },
];
export const BranchTransRecExcelHeaderFormattedLRNO = [
    { header: 'S/N', field: 'sno' },
    { header: 'Formatted LRNO', field: 'FormattedLRNO' },
    { header: 'Man.LR No', field: 'LRNO' },
    { header: 'Challan No', field: 'ChallanNo' },
    { header: 'Trans. Date', field: 'ReceiptDate' },
    { header: 'Trans. Time', field: 'ReceiptDate' },
    { header: 'Sndr. Name', field: 'Sender' },
    { header: 'Sndr. No.', field: 'Sender' },
    { header: 'Sndr. GSTIN', field: 'SenderGSTN' },
    { header: 'Sndr. eMail.', field: 'SenderGSTN' },
    { header: 'Rcvr. Name', field: 'RecName' },
    { header: 'Rcvr. No', field: 'RecName' },
    { header: 'Rcvr. GSTIN', field: 'ReceiverGSTN' },
    { header: 'Rcvr. eMail', field: 'ReceiverGSTN' },
    { header: 'Item Details', field: 'ItemDetails' },
    { header: 'Item Units', field: 'Units' },
    { header: 'Frt Chrg', field: 'Freight' },
    { header: 'Cart. Chrg.', field: 'CartageAmount' },
    { header: 'Ham. Chrg.', field: 'HamaliCharge' },
    { header: 'Oth. Chrg.', field: 'OtherCharges' },
    { header: 'Val. Chrg.', field: 'Valuation' },
    { header: 'Bkg. GST', field: 'BookingGST' },
    { header: 'Net. Amt.', field: 'NetAmount' },
];
export const getBranchTransRecExcelHeader = (loginCountryId, UseFormattedLRinReports,loginData) => {
    let columns = [
        { header: 'Serial Number', field: 'sno' },
        { header: 'LR Number', field: 'LRNO' },
        { header: 'Manual LR Number', field: 'LRNO' },
        { header: 'Formatted LR Number', field: 'FormattedLRNO' },
        { header: 'Challan Number', field: 'ChallanNo' },
        { header: 'Transaction Date', field: 'ReceiptDate' },
        { header: 'Transaction Time', field: 'ReceiptDate' },
        { header: 'Sender Name', field: 'Sender' },
        { header: 'Sender Number', field: 'Sender' },
        { header: 'Sender GSTIN', field: 'SenderGSTN' },
        { header: 'Sender eMail.', field: 'SenderGSTN' },
        { header: 'Receiver Name', field: 'RecName' },
        { header: 'Receiver Number', field: 'RecName' },
        { header: 'Receiver GSTIN', field: 'ReceiverGSTN' },
        { header: 'Receiver eMail', field: 'ReceiverGSTN' },
        { header: 'Item Details', field: 'ItemDetails' },
        { header: 'Item Units', field: 'Units' },
        { header: 'Freight Charge', field: 'Freight' },
        { header: 'Cartage Charge', field: 'CartageAmount' },
        { header: 'Hamali Charge', field: 'HamaliCharge' },
        { header: 'Other Charge', field: 'OtherCharges' },
        { header: 'Valuation Charge', field: 'Valuation' },
        { header: 'Booking GST', field: 'BookingGST' },
        { header: 'Net Amount', field: 'NetAmount' },
    ];
    if (UseFormattedLRinReports !== 3) {
        columns = columns.filter(col => col.field !== 'FormattedLRNO');
    }
    if (loginCountryId === 2) {
        columns = columns.filter(col => col.field !== 'BookingGST');
    }
    if (loginData.intCompanyID === RAJESH_TRANSPORT) {
        columns.push({ header: 'Remarks', field: 'Remarks' });
    }
    columns = columns.map(col => {
        if (col.field === 'Valuation') {
            return {
                ...col,
                header: loginCountryId === 2 ? 'Insurance Charge' : 'Valuation Charge',
            };
        }
        return col;
    });
    return columns;
};
export const BranchTransRecExcelHeaderForRemoveGST = [
    { header: 'S/N', field: 'sno' },
    { header: 'LR No', field: 'LRNO' },
    { header: 'Man.LR No', field: 'LRNO' },
    { header: 'Formatted LRNO', field: 'FormattedLRNO' },
    { header: 'Challan No', field: 'ChallanNo' },
    { header: 'Trans. Date', field: 'ReceiptDate' },
    { header: 'Trans. Time', field: 'ReceiptDate' },
    { header: 'Sndr. Name', field: 'Sender' },
    { header: 'Sndr. No.', field: 'Sender' },
    { header: 'Sndr. eMail.', field: 'SenderGSTN' },
    { header: 'Rcvr. Name', field: 'RecName' },
    { header: 'Rcvr. No', field: 'RecName' },
    { header: 'Rcvr. eMail', field: 'ReceiverGSTN' },
    { header: 'Item Details', field: 'ItemDetails' },
    { header: 'Item Units', field: 'Units' },
    { header: 'Frt Chrg', field: 'Freight' },
    { header: 'Cart. Chrg.', field: 'CartageAmount' },
    { header: 'Ham. Chrg.', field: 'HamaliCharge' },
    { header: 'Oth. Chrg.', field: 'OtherCharges' },
    { header: 'Val. Chrg.', field: 'Valuation' },
    { header: 'Net. Amt.', field: 'NetAmount' },
];
